import WithdrawDetailPage from '../pages/Withdraw/Withdraw/Detail'
import MessageListPage from '../pages/message'
import AssetLogListPage from '../pages/assets/LogList'
import AssetLogDetailPage from '../pages/assets/LogList/Detail'
import BillDownloadPage from '../pages/cards/BillList/Download'
import RouteConstant from "@/constant/RouteConstant";

const withDrawRoutes = [
  {
    path: RouteConstant.WITHDRAW_DETAIL,
    element: <WithdrawDetailPage />
  },
]

const messageRoutes = [
  {
    path: RouteConstant.MESSAGE_LIST,
    element: <MessageListPage />
  }
]

const assetLogRoutes = [
  {
    path: RouteConstant.ASSET_LOG_LIST,
    element: <AssetLogListPage />
  },
  {
    path: RouteConstant.ASSET_LOG_DETAIL,
    element: <AssetLogDetailPage />
  }
]

const billRoutes = [
  {
    path: RouteConstant.CARD_BILL_DOWNLOAD,
    element: <BillDownloadPage />
  }
]

export {
  withDrawRoutes,
  messageRoutes,
  assetLogRoutes,
  billRoutes
}